'use strict'
export default class Fileuploadpost {
    constructor(
        _id_user='',
        type='',
        link='',
        name='',
    ) {
        this._id_user = _id_user
        this.type = type
        this.link = link
        this.name = name
    }

}